(function () {
  "use strict";

  // ---------- tuning ranges ----------
  let FREQ_MIN = 1.0, FREQ_MAX = 4.2;       // cycles across the visible width
  let AMP_MIN = 0.10, AMP_MAX = 1.05;       // fraction of half chart height
  let TARGET_FREQ_MIN = 1.2, TARGET_FREQ_MAX = 3.8;
  let TARGET_AMP_MIN = 0.25, TARGET_AMP_MAX = 0.95;

  let FREQ_STEP = 0.04;    // discrete step per keypress
  let AMP_STEP = 0.025;     // discrete step per keypress
  let MATCH_FREQ_THRESHOLD = 0.04;
  let MATCH_AMP_THRESHOLD = 0.04;
  let HOLD_DURATION_MS = 2000;
  let SCROLL_SPEED_PX_PER_MS = 0.05;

  let MIN_START_OFFSET_FREQ = 1.0;  // minimum starting distance from target (absolute units)
  let  MIN_START_OFFSET_AMP = 0.3;   // minimum starting distance from target (absolute units)

  let  ROUNDS_DEFAULT = 5;
  let  ROUND_MS_DEFAULT = 40000;

  // ---------- dom refs ----------
  let svg = document.getElementById("scope-svg");
  let field = document.getElementById("field");

  let statusTag = document.getElementById("status-tag");
  let lockTag = document.getElementById("lock-tag");
  let locksTag = document.getElementById("locks-tag");
  let dfTag = document.getElementById("df-tag");
  let daTag = document.getElementById("da-tag");
  let holdFill = document.getElementById("hold-fill");
  let ttlFill = document.getElementById("ttl-fill");
  let ttlTag = document.getElementById("ttl-tag");

  let splashScreen = document.getElementById("splash-screen");
  let winScreen = document.getElementById("win-screen");
  let loseScreen = document.getElementById("lose-screen");

  let startBtn = document.getElementById("start-btn");
  let winRetryBtn = document.getElementById("win-retry-btn");
  let loseRetryBtn = document.getElementById("lose-retry-btn");

  let roundsSlider = document.getElementById("rounds");
  let roundsValueEl = document.getElementById("rounds-value");
  let gameTimeSlider = document.getElementById("game-time");
  let gameTimeValueEl = document.getElementById("game-time-value");

  // ---------- svg paths ----------
  let NS = "http://www.w3.org/2000/svg";
  let pathTarget = document.createElementNS(NS, "path");
  pathTarget.setAttribute("class", "wave-path wave-target");
  let pathPlayer = document.createElementNS(NS, "path");
  pathPlayer.setAttribute("class", "wave-path wave-player");
  svg.appendChild(pathTarget);
  svg.appendChild(pathPlayer);

  // ---------- state ----------
  let running = false;
  let totalRounds = ROUNDS_DEFAULT;
  let ROUND_MS = ROUND_MS_DEFAULT;

  let targetFreq = 2, targetAmp = 0.5;
  let playerFreq = 1.5, playerAmp = 0.3;

  let locksFound = 0;
  let holdMs = 0;
  let matched = false;

  let startTime = null;
  let lastFrame = null;
  let phase = 0;

  function rand(min, max) { return min + Math.random() * (max - min); }
  function clamp(v, min, max) { return Math.min(max, Math.max(min, v)); }
  function snap(v, step) { return Math.round(v / step) * step; }
  function roundTo(v, decimals) {
    let f = Math.pow(10, decimals);
    return Math.round(v * f) / f;
  }

  function formatRoundTime(totalSeconds) {
    let m = Math.floor(totalSeconds / 60);
    let s = totalSeconds % 60;
    return String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
  }

  function formatTime(ms) {
    let totalSec = Math.max(0, ms) / 1000;
    let m = Math.floor(totalSec / 60);
    let s = totalSec - m * 60;
    return String(m).padStart(2, "0") + ":" + s.toFixed(1).padStart(4, "0");
  }

  // ---------- config labels ----------
  function updateRoundsLabel() { roundsValueEl.textContent = roundsSlider.value; }
  function updateGameTimeLabel() { gameTimeValueEl.textContent = formatRoundTime(parseInt(gameTimeSlider.value, 10)); }

  roundsSlider.addEventListener("input", updateRoundsLabel);
  gameTimeSlider.addEventListener("input", updateGameTimeLabel);

  function readConfig() {
    totalRounds = parseInt(roundsSlider.value, 10);
    ROUND_MS = parseInt(gameTimeSlider.value, 10) * 1000;
  }

  function setSlidersDisabled(disabled) {
    roundsSlider.disabled = disabled;
    gameTimeSlider.disabled = disabled;
  }

  // ---------- round setup ----------
  function newRound() {
    targetFreq = roundTo(snap(rand(TARGET_FREQ_MIN, TARGET_FREQ_MAX), FREQ_STEP), 2);
    targetAmp = roundTo(snap(rand(TARGET_AMP_MIN, TARGET_AMP_MAX), AMP_STEP), 2);

    // start the player's carrier at a fully random position, far enough from the target
    let  attempts = 0;
    do {
      playerFreq = roundTo(snap(rand(FREQ_MIN, FREQ_MAX), FREQ_STEP), 2);
      attempts++;
    } while (Math.abs(playerFreq - targetFreq) < MIN_START_OFFSET_FREQ && attempts < 50);

    attempts = 0;
    do {
      playerAmp = roundTo(snap(rand(AMP_MIN, AMP_MAX), AMP_STEP), 2);
      attempts++;
    } while (Math.abs(playerAmp - targetAmp) < MIN_START_OFFSET_AMP && attempts < 50);

    holdMs = 0;
    matched = false;
    holdFill.style.width = "0%";
  }

  // ---------- rendering ----------
  function buildPath(freq, amp, width, height) {
    let centerY = height / 2;
    let ampPx = amp * (height / 2) * 0.85;
    let k = (2 * Math.PI * freq) / width;
    let step = 4;
    let d = "";
    for (let x = 0; x <= width; x += step) {
      let y = centerY - ampPx * Math.sin(k * (x + phase));
      d += (x === 0 ? "M " : "L ") + x.toFixed(1) + " " + y.toFixed(1) + " ";
    }
    return d;
  }

  function draw() {
    let width = field.clientWidth || 900;
    let height = field.clientHeight || 360;
    svg.setAttribute("viewBox", "0 0 " + width + " " + height);

    pathTarget.setAttribute("d", buildPath(targetFreq, targetAmp, width, height));
    pathPlayer.setAttribute("d", buildPath(playerFreq, playerAmp, width, height));
  }

  // ---------- game flow ----------
  function setStatus(text, cls) {
    statusTag.textContent = text;
    statusTag.classList.remove("running", "failed", "cleared");
    if (cls) statusTag.classList.add(cls);
  }

  function resetGame() {
    readConfig();

    locksFound = 0;
    newRound();

    startTime = null;
    lastFrame = null;
    running = true;

    setStatus("BREACHING", "running");
    lockTag.textContent = "LOCK " + locksFound + "/" + totalRounds;
    locksTag.textContent = "LOCKS " + locksFound + "/" + totalRounds;
    ttlFill.style.width = "100%";
    ttlTag.textContent = "TTL " + formatTime(ROUND_MS);

    splashScreen.classList.add("hidden");
    winScreen.classList.add("hidden");
    loseScreen.classList.add("hidden");
    setSlidersDisabled(true);
  }

  function endGame(won) {
    running = false;
    setSlidersDisabled(false);

    if (won) {
      setStatus("ACCESS GRANTED", "cleared");
      winScreen.classList.remove("hidden");
    } else {
      setStatus("BREACH FAILED", "failed");
      loseScreen.classList.remove("hidden");
    }
  }

  // ---------- main loop (always running so the scope keeps sliding) ----------
  function loop(timestamp) {
    if (lastFrame === null) lastFrame = timestamp;
    let dt = timestamp - lastFrame;
    lastFrame = timestamp;

    phase += dt * SCROLL_SPEED_PX_PER_MS;

    if (running) {
      if (startTime === null) startTime = timestamp;

      let elapsed = timestamp - startTime;
      let remaining = ROUND_MS - elapsed;
      let pct = Math.max(0, (remaining / ROUND_MS) * 100);
      ttlFill.style.width = pct + "%";
      ttlTag.textContent = "TTL " + formatTime(Math.max(0, remaining));

      let df = Math.abs(playerFreq - targetFreq);
      let da = Math.abs(playerAmp - targetAmp);
      dfTag.textContent = "\u0394f " + df.toFixed(2);
      daTag.textContent = "\u0394a " + da.toFixed(2);

      let freqMatched = df < MATCH_FREQ_THRESHOLD;
      let ampMatched = da < MATCH_AMP_THRESHOLD;
      dfTag.classList.toggle("in-range", freqMatched);
      dfTag.classList.toggle("out-range", !freqMatched);
      daTag.classList.toggle("in-range", ampMatched);
      daTag.classList.toggle("out-range", !ampMatched);

      matched = freqMatched && ampMatched;

      if (matched) {
        holdMs += dt;
      } else {
        holdMs = 0;
      }
      let holdPct = Math.min(100, (holdMs / HOLD_DURATION_MS) * 100);
      holdFill.style.width = holdPct + "%";

      if (holdMs >= HOLD_DURATION_MS) {
        locksFound += 1;
        lockTag.textContent = "LOCK " + locksFound + "/" + totalRounds;
        locksTag.textContent = "LOCKS " + locksFound + "/" + totalRounds;

        if (locksFound >= totalRounds) {
          endGame(true);
        } else {
          newRound();
        }
      } else if (remaining <= 0) {
        endGame(false);
      }
    }

    draw();
    requestAnimationFrame(loop);
  }

  function adjustFreq(dir) {
    playerFreq = roundTo(clamp(playerFreq + dir * FREQ_STEP, FREQ_MIN, FREQ_MAX), 2);
  }

  function adjustAmp(dir) {
    playerAmp = roundTo(clamp(playerAmp + dir * AMP_STEP, AMP_MIN, AMP_MAX), 2);
  }

  // ---------- input ----------
  window.addEventListener("keydown", function (e) {
    if (e.key === " " || e.key === "Enter" || e.key === "Spacebar") {
      if (!running) {
        if (!splashScreen.classList.contains("hidden") ||
            !winScreen.classList.contains("hidden") ||
            !loseScreen.classList.contains("hidden")) {
          if (e.repeat) return;
          e.preventDefault();
          resetGame();
        }
      }
      return;
    }

    if (!running) return;

    switch (e.key) {
      case "ArrowLeft": adjustFreq(-1); e.preventDefault(); break;
      case "ArrowRight": adjustFreq(1); e.preventDefault(); break;
      case "ArrowUp": adjustAmp(1); e.preventDefault(); break;
      case "ArrowDown": adjustAmp(-1); e.preventDefault(); break;
    }
  });

  // ---------- buttons ----------
  startBtn.addEventListener("click", resetGame);
  winRetryBtn.addEventListener("click", resetGame);
  loseRetryBtn.addEventListener("click", resetGame);

  // ---------- initial paint ----------
  updateRoundsLabel();
  updateGameTimeLabel();
  lockTag.textContent = "LOCK 0/" + roundsSlider.value;
  locksTag.textContent = "LOCKS 0/" + roundsSlider.value;
  ttlTag.textContent = "TTL " + formatTime(parseInt(gameTimeSlider.value, 10) * 1000);
  newRound();
  requestAnimationFrame(loop);
})();
